import React from 'react';

const Spinner = ({ size = 'default', text = 'Loading...' }) => {
  return (
    <div className="flex flex-col items-center justify-center py-20 w-full col-span-full min-h-[300px]">
      <div className="bg-[#131418] border border-white/10 shadow-2xl p-8 rounded-3xl flex flex-col items-center justify-center min-w-[250px]">
        <div className="flex gap-4 mb-6 mt-2 h-12 items-center drop-shadow-2xl">
          <div className="candle"></div>
          <div className="candle"></div>
          <div className="candle"></div>
        </div>
        {text && <p className="text-white font-bold text-[14px] tracking-widest uppercase animate-pulse drop-shadow-2xl">{text}</p>}
      </div>
    </div>
  );
};

export default Spinner;
